import { Sizes } from "../../constants/size";
import type { IconProps } from "../../types/icon-props";

export const Telegram = (props: IconProps) => {
  const {
    size = "md",
    fill = "var(--grey-1)",
    stroke = "var(--grey-1)",
    ...rest
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 33 32"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#clip0_9813_192)">
        <path
          d="M16.7567 32.0133C25.5969 32.0133 32.7633 24.8469 32.7633 16.0067C32.7633 7.16643 25.5969 0 16.7567 0C7.91643 0 0.75 7.16643 0.75 16.0067C0.75 24.8469 7.91643 32.0133 16.7567 32.0133Z"
          fill="url(#paint0_linear_9813_192)"
        />
        <path
          d="M7.98693 15.8333C12.6517 13.8075 15.757 12.4614 17.3164 11.8083C21.7545 9.95575 22.6875 9.63589 23.2872 9.62256C23.4205 9.62256 23.7137 9.64921 23.9136 9.80915C24.0736 9.94243 24.1135 10.1157 24.1402 10.249C24.1669 10.3822 24.1935 10.6621 24.1669 10.8754C23.927 13.4076 22.8874 19.5518 22.3543 22.3772C22.1277 23.5767 21.6879 23.9766 21.2614 24.0166C20.3285 24.0965 19.6221 23.4035 18.7291 22.8171C17.3164 21.8974 16.53 21.3243 15.1573 20.4181C13.5713 19.3785 14.5975 18.8054 15.5038 17.8725C15.7437 17.6326 19.8353 13.9008 19.9153 13.5676C19.9286 13.5276 19.9286 13.3677 19.8353 13.2877C19.742 13.2077 19.6088 13.2344 19.5021 13.261C19.3555 13.2877 17.1165 14.7804 12.7583 17.7258C12.1185 18.1657 11.5454 18.3789 11.0257 18.3656C10.4526 18.3523 9.35969 18.0457 8.53337 17.7792C7.53379 17.4593 6.73412 17.286 6.80076 16.7263C6.84074 16.4331 7.24057 16.1398 7.98693 15.8333Z"
          fill="white"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9813_192"
          x1="16.7433"
          y1="0"
          x2="16.7433"
          y2="31.7601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2AABEE" />
          <stop offset="1" stopColor="#229ED9" />
        </linearGradient>
        <clipPath id="clip0_9813_192">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

Telegram.displayName = "Telegram";
